export default "__VITE_ASSET__DfMcmR9R__"